var _style, _polygon, _polygon2, _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 631.8 800",
    style: {
      enableBackground: "new 0 0 631.8 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.3361,
    y1: -1288.3475,
    x2: 701.044,
    y2: -1721.2361,
    gradientTransform: "matrix(1 0 0 -1 0 -814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F23B00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0667,
    style: {
      stopColor: "#F21E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4061,
    style: {
      stopColor: "#F25300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#F21900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9576,
    style: {
      stopColor: "#BA0000"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "315.9,457.2 164,469.7 164,796 315.9,743.3 467.7,796 467.7,469.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.8814,
    y1: -1306.5665,
    x2: 733.7625,
    y2: -1665.6458,
    gradientTransform: "matrix(1 0 0 -1 0 -814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F23B00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0667,
    style: {
      stopColor: "#F21E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4061,
    style: {
      stopColor: "#F25300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#F21900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9576,
    style: {
      stopColor: "#BA0000"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "315.9,457.2 164,469.7 164,796 315.9,743.3 467.7,796 467.7,469.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.9738,
    y1: -1177.3954,
    x2: 468.6015,
    y2: -1494.0232,
    gradientTransform: "matrix(1 0 0 -1 0 -814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0667,
    style: {
      stopColor: "#C70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4061,
    style: {
      stopColor: "#C71800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#C70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9576,
    style: {
      stopColor: "#8F0000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164,457.7v139.3c47.3,27.6,101.2,42.4,157.4,42.4c51.8,0,101.7-12.5,146.2-36.1V457.7l-151.8-12.5L164,457.7 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.9786,
    y1: -828.1616,
    x2: 449.1523,
    y2: -1434.1312,
    gradientTransform: "matrix(1 0 0 -1 0 -814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0667,
    style: {
      stopColor: "#FFBD67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2242,
    style: {
      stopColor: "#FFC870"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4061,
    style: {
      stopColor: "#FFF29B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FFB861"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9576,
    style: {
      stopColor: "#F59442"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315.9,629.4c-83.5,0-162.1-32.5-221.1-91.6C35.7,478.8,3.2,400.2,3.2,316.7c0-83.5,32.5-162.1,91.6-221.1 C153.8,36.5,232.3,4,315.9,4S477.9,36.5,537,95.6c59.1,59.1,91.6,137.6,91.6,221.1c0,83.5-32.5,162.1-91.6,221.1 C477.9,596.9,399.4,629.4,315.9,629.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.879,
    y1: -805.8386,
    x2: 315.879,
    y2: -1461.0137,
    gradientTransform: "matrix(1 0 0 -1 0 -814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E16A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    style: {
      stopColor: "#FFDA82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0667,
    style: {
      stopColor: "#FFBD67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1326,
    style: {
      stopColor: "#FFEB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2242,
    style: {
      stopColor: "#FFC870"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4696,
    style: {
      stopColor: "#FFF29B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    style: {
      stopColor: "#9C4518"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7569,
    style: {
      stopColor: "#FFC870"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC773"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 315.9,
    cy: 316.7,
    r: 306.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 675.7819,
    y1: -1490.6222,
    x2: 95.4858,
    y2: -910.326,
    gradientTransform: "matrix(1 0 0 -1 0 -814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B1B00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0667,
    style: {
      stopColor: "#996E37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1939,
    style: {
      stopColor: "#EB9154"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#963014"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 315.9,
    cy: 316.7,
    r: 282.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.1519,
    y1: -842.9921,
    x2: 578.7209,
    y2: -1393.561,
    gradientTransform: "matrix(1 0 0 -1 0 -814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0667,
    style: {
      stopColor: "#FFBD67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2242,
    style: {
      stopColor: "#FFC870"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4061,
    style: {
      stopColor: "#FFF29B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#FFB861"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9576,
    style: {
      stopColor: "#F59442"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 315.9,
    cy: 316.7,
    r: 276.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.01f5d17f3de9537ae27fba50da3b6ce2.svg";
export { ForwardRef as ReactComponent };